import {
  __spreadProps,
  __spreadValues
} from "./chunk-32ZPS4GN.mjs";

// src/theme/generate.ts
var flattenTokens = (tokenGroups, prefix = "") => {
  return Object.entries(tokenGroups).reduce(
    (result, [groupKey, groupValue]) => {
      if ("light" in groupValue) {
        const newKey = [prefix, groupKey].filter(Boolean).join("-");
        return __spreadProps(__spreadValues({}, result), {
          [newKey]: groupValue
        });
      }
      const newPrefix = [prefix, groupKey].filter(Boolean).join("-");
      return __spreadValues(__spreadValues({}, result), flattenTokens(groupValue, newPrefix));
    },
    {}
  );
};
var generateTailwindTokens = (flattenedTokens) => {
  const tokens = {
    backgroundColor: {},
    textColor: {},
    borderColor: {},
    outlineColor: {},
    ringColor: {}
  };
  Object.keys(flattenedTokens).forEach((key) => {
    const value = `var(--${key}, ${flattenedTokens[key].light})`;
    if (key.includes("surface")) {
      tokens.backgroundColor[key.replace(/-default/g, "")] = value;
    } else if (key.includes("foreground")) {
      tokens.textColor[key.replace(/-default/g, "")] = value;
    } else if (key.includes("border")) {
      const newKey = key.replace(/border-|-border/g, "").replace("default", "DEFAULT");
      tokens.borderColor[newKey] = value;
      tokens.outlineColor[newKey] = value;
      tokens.ringColor[newKey] = value;
    }
  });
  return tokens;
};
var generateThemeVariables = (flattenedTokens) => {
  return Object.keys(flattenedTokens).reduce(
    (variables, key) => {
      const value = flattenedTokens[key];
      return {
        ":root": __spreadProps(__spreadValues({}, variables[":root"]), {
          [`--${key}`]: value.light
        }),
        ".dark": __spreadProps(__spreadValues({}, variables[".dark"]), {
          [`--${key}`]: value.dark
        })
      };
    },
    { ":root": {}, ".dark": {} }
  );
};
var generateCustomThemeVariables = (flattenedTokens) => {
  return Object.keys(flattenedTokens).reduce(
    (variables, key) => {
      const value = flattenedTokens[key];
      return {
        ":root": `${variables[":root"]} 
--${key}: ${value.light};`,
        ".dark": `${variables[".dark"]} 
--${key}: ${value.dark};`
      };
    },
    { ":root": "", ".dark": "" }
  );
};

export {
  flattenTokens,
  generateTailwindTokens,
  generateThemeVariables,
  generateCustomThemeVariables
};
